import { render } from "./IndicatorPage.vue?vue&type=template&id=51947945"
import script from "./IndicatorPage.vue?vue&type=script&lang=js"
export * from "./IndicatorPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__